var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"toast df jc-sb",class:{show:_vm.show,close:_vm.close}},[_c('h4',[_vm._v(_vm._s(_vm.err))]),_c('button',{attrs:{"type":"button"},on:{"click":function($event){_vm.close=true,_vm.show=false}}},[_vm._v("×")])])}
var staticRenderFns = []

export { render, staticRenderFns }